<style scoped>
</style>

<template>
  <section class="container">
    form params
  </section>
</template>

<script>
  export default {
    mounted () {
      if (!(this.$store.state.admin && this.$store.state.admin.token)) {
        this.$router.push('/403')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/admin/parametroPortal/Form.vue